const data = {
  data: [
    {
      id: 1,
      name: 'Kuhn-Volkman',
      company_id: 7,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      master_business: null,
      address: '46051 Greenholt Pines Apt. 885',
      zip_code: '21782',
      description: 'Voluptatem totam facilis eius minima. Fuga accusantium alias modi explicabo vel distinctio.',
      city: 'Elwinfurt',
      state_id: null,
      country: 'VG',
      map_url: 'http://quitzon.com/velit-doloremque-reprehenderit-fugit-veniam-suscipit-earum-dolores',
      phone: '926.346.2740',
      mails: 'marietta.osinski@stark.net',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 2,
      name: 'Smith, Grady and Huels',
      company_id: 5,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      master_business: null,
      address: '5352 Ashtyn Road Apt. 235',
      zip_code: '46904-0807',
      description: 'Repellat similique voluptas perspiciatis magnam quia nihil corrupti. A nam beatae et ut explicabo.',
      city: 'Brekkemouth',
      state_id: null,
      country: 'OM',
      map_url: 'http://collier.com/est-eius-qui-fugiat-possimus',
      phone: '+16519723445',
      mails: 'phoebe16@hotmail.com',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 3,
      name: 'Beier LLC',
      company_id: 6,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      master_business: null,
      address: '22965 Carole Shore',
      zip_code: '82057-8271',
      description: 'Dolorem provident ad magni veniam quisquam voluptatum voluptas et. Debitis minus sed quia voluptas. Commodi sed sint et natus dicta deserunt est dolor.',
      city: 'West Jovany',
      state_id: null,
      country: 'NR',
      map_url: 'http://www.daniel.com/magnam-dolores-dignissimos-eaque-aspernatur.html',
      phone: '+12588935277',
      mails: 'lrippin@gmail.com',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 4,
      name: 'Breitenberg Ltd',
      company_id: 7,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      master_business: null,
      address: '9074 Fahey Ports Suite 811',
      zip_code: '21957',
      description: 'Ipsa perspiciatis temporibus illum quae natus. Quas enim minus id praesentium.',
      city: 'Wisokychester',
      state_id: null,
      country: 'NO',
      map_url: 'http://www.lesch.com/vel-ut-vel-ea-adipisci-rerum-vero-quaerat.html',
      phone: '+19407214435',
      mails: 'twatsica@strosin.com',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 5,
      name: 'Corwin, Feil and Bednar',
      company_id: 6,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      master_business: null,
      address: '40040 Brown Motorway Suite 590',
      zip_code: '45832',
      description: 'A nesciunt minima quidem ducimus corrupti velit sed vel. Aut qui impedit consectetur rerum similique aspernatur.',
      city: 'Dandreland',
      state_id: null,
      country: 'PH',
      map_url: 'http://www.wilderman.info/ut-id-nesciunt-eligendi-dignissimos-a-dolore-consectetur-sint',
      phone: '+12424951389',
      mails: 'terry72@yahoo.com',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 6,
      name: "Tillman, Larson and O'Connell",
      company_id: 1,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-07-14T08:40:12.000000Z',
      deleted_at: null,
      master_business: null,
      address: '31337 Herman Inlet Suite 319',
      zip_code: '48868',
      description: 'Dolor nesciunt modi quaerat voluptatem omnis veritatis amet.',
      city: 'New Lorna',
      state_id: null,
      country: 'UM',
      map_url: 'http://www.herman.org/voluptas-consectetur-error-omnis-provident',
      phone: '1-456-278-6184',
      mails: 'daugherty.camille@mayer.com',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 7,
      name: 'Bosco Group',
      company_id: 9,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      master_business: null,
      address: '1096 Noemy Cove',
      zip_code: '89844-3995',
      description: 'Non accusantium velit repellendus itaque reiciendis ratione. Voluptas voluptas aliquam odio quas voluptas corporis.',
      city: 'Schaefermouth',
      state_id: null,
      country: 'RS',
      map_url: 'http://www.runte.com/alias-voluptatem-non-provident-ab.html',
      phone: '+1 (878) 357-6013',
      mails: 'ndickens@ruecker.com',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 8,
      name: 'Denesik LLC',
      company_id: 2,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      master_business: null,
      address: '12812 Tia Trail',
      zip_code: '24132-6188',
      description: 'Eum non eaque delectus repudiandae exercitationem animi. Nam vitae in explicabo.',
      city: 'Rolfsonport',
      state_id: null,
      country: 'KH',
      map_url: 'http://www.borer.com/nisi-consequatur-tempore-voluptas-optio-impedit.html',
      phone: '(501) 226-9670',
      mails: 'cornelius62@gmail.com',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 9,
      name: 'Runte-Wisozk 2',
      company_id: 1,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-07-14T08:44:41.000000Z',
      deleted_at: null,
      master_business: null,
      address: '555 Josue Mountain',
      zip_code: '88169-1331',
      description: 'Mollitia voluptatibus sed iste iste. Omnis molestias ut et necessitatibus. Optio qui necessitatibus eos consequatur fugit temporibus iure ratione. Animi voluptatem fugit harum non fugiat. Quod incidunt explicabo aliquam itaque.',
      city: 'Tremblayton',
      state_id: null,
      country: 'MM',
      map_url: 'http://turcotte.com/et-consequatur-nostrum-est-dolorum-sunt-et.html',
      phone: '+1-705-888-8026',
      mails: 'nella.wisozk@hotmail.com',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 10,
      name: 'Hills PLC',
      company_id: 8,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      master_business: null,
      address: '919 Ashlee Stravenue Apt. 902',
      zip_code: '39302-0012',
      description: 'Soluta ut voluptatum pariatur non iure. Ab illum quasi magni.',
      city: 'Murrayport',
      state_id: null,
      country: 'TJ',
      map_url: 'https://www.cassin.net/quia-asperiores-est-ducimus-rem',
      phone: '+1-471-861-3107',
      mails: 'bill97@leffler.com',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 11,
      name: 'Monahan-Brown',
      company_id: 9,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      master_business: null,
      address: '29943 Nick Manor',
      zip_code: '70118',
      description: 'Quas enim earum illo qui. Ut officia earum molestias illum ipsam optio ut.',
      city: 'Shanefurt',
      state_id: null,
      country: 'BW',
      map_url: 'https://www.abernathy.net/aut-accusamus-cupiditate-accusantium-iusto-similique-similique-temporibus',
      phone: '671.459.2833',
      mails: 'wilber88@runolfsdottir.info',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 12,
      name: 'Christiansen, Tromp and Paucek',
      company_id: 9,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      master_business: null,
      address: '614 Dave Viaduct Suite 590',
      zip_code: '77633',
      description: 'Quae iusto qui quia voluptates culpa repudiandae. Qui dolorem cumque deserunt consectetur iusto ea. Eos suscipit maxime in qui suscipit qui dolores. Sed ab ducimus earum aliquam pariatur dolorem minima.',
      city: 'New Alfred',
      state_id: null,
      country: 'SX',
      map_url: 'http://klein.net/',
      phone: '212.349.1237',
      mails: 'tracy.heathcote@hotmail.com',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 13,
      name: 'Doyle, Roob and DuBuque',
      company_id: 9,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:57.000000Z',
      deleted_at: null,
      master_business: null,
      address: '283 Nienow Parks Suite 876',
      zip_code: '91876-1046',
      description: 'Tenetur omnis temporibus sint est qui atque maxime explicabo. Qui aperiam recusandae eligendi et et.',
      city: 'West Jackie',
      state_id: null,
      country: 'AZ',
      map_url: 'http://kohler.net/',
      phone: '1-286-310-1371',
      mails: 'teffertz@yahoo.com',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 14,
      name: 'Hirthe LLC',
      company_id: 1,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:56.000000Z',
      deleted_at: null,
      master_business: null,
      address: '304 Beatty Glen',
      zip_code: '55714-3954',
      description: 'Quos saepe totam voluptatem aut. Magni omnis aut neque voluptatum. Reiciendis incidunt id aut fuga est sed explicabo. Optio enim nesciunt ipsa consectetur hic non. Explicabo sequi commodi explicabo pariatur inventore sed.',
      city: 'Paoloburgh',
      state_id: null,
      country: 'FM',
      map_url: 'http://www.hane.net/',
      phone: '+1.475.560.5597',
      mails: 'brandi.gibson@yahoo.com',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 15,
      name: 'Leuschke-Gleason',
      company_id: 1,
      created_at: '2021-05-25T15:33:56.000000Z',
      updated_at: '2021-05-25T15:33:56.000000Z',
      deleted_at: null,
      master_business: null,
      address: '508 Purdy Mill Suite 366',
      zip_code: '12522',
      description: 'Asperiores nobis velit ratione ducimus quidem. Nulla quia voluptatem temporibus vel. Autem quidem qui ipsum perspiciatis a quo qui non.',
      city: 'Beattyland',
      state_id: null,
      country: 'LV',
      map_url: 'https://www.mckenzie.com/ut-dolorem-sed-omnis-optio-dolorum-eveniet',
      phone: '(237) 306-9722',
      mails: 'abbott.loyal@lebsack.com',
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: null
    },
    {
      id: 17,
      name: 'Adarsa Oviedo',
      company_id: 10,
      created_at: null,
      updated_at: '2021-08-06T12:00:36.000000Z',
      deleted_at: null,
      master_business: 'A01',
      address: 'c/ Paredes s/n',
      zip_code: null,
      description: null,
      city: null,
      state_id: null,
      country: 'ES',
      map_url: null,
      phone: null,
      mails: null,
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: 'APPOVI'
    },
    {
      id: 18,
      name: 'Adarsa Gijón',
      company_id: 10,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      master_business: 'A02',
      address: null,
      zip_code: null,
      description: null,
      city: null,
      state_id: null,
      country: null,
      map_url: null,
      phone: null,
      mails: null,
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: 'APPGIJ'
    },
    {
      id: 19,
      name: 'Adarsa Benavente',
      company_id: 10,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      master_business: 'A03',
      address: null,
      zip_code: null,
      description: null,
      city: null,
      state_id: null,
      country: null,
      map_url: null,
      phone: null,
      mails: null,
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: 'APPBEN'
    },
    {
      id: 20,
      name: 'Adarsa Ponferrada',
      company_id: 10,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      master_business: 'A04',
      address: null,
      zip_code: null,
      description: null,
      city: null,
      state_id: null,
      country: null,
      map_url: null,
      phone: null,
      mails: null,
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: 'APPPON'
    },
    {
      id: 21,
      name: 'Adarsa Zamora',
      company_id: 10,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      master_business: 'A05',
      address: null,
      zip_code: null,
      description: null,
      city: null,
      state_id: null,
      country: null,
      map_url: null,
      phone: null,
      mails: null,
      days_closed: null,
      hours: null,
      num_appointments: null,
      hours_before: null,
      default_appointment_status: null,
      temporal_code: 'APPZAM'
    }
  ],
  links: {
    first: 'http://localhost/api/v1/businesses?page=1',
    last: 'http://localhost/api/v1/businesses?page=3',
    prev: null,
    next: 'http://localhost/api/v1/businesses?page=2'
  },
  meta: {
    current_page: 1,
    from: 1,
    last_page: 3,
    links: [
      {
        url: null,
        label: '&laquo; Anterior',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=1',
        label: '1',
        active: true
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: '2',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=3',
        label: '3',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: 'Siguiente &raquo;',
        active: false
      }
    ],
    path: 'http://localhost/api/v1/businesses',
    per_page: 20,
    to: 20,
    total: 41,
    search: {}
  }
}

export default data
